<script setup lang="ts">
import { computed, ref, watch } from 'vue';

// Props tanımı
const $props = defineProps<{
  modelValue?: boolean;
  toggleAccept?: boolean;
}>();

const $slots = defineSlots<{
  activator: (props: { toggleDialog: () => void }) => any;
}>();

// Emit tanımı
const $emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'accept'): void;
}>();

// İç state (eğer modelValue verilmemişse kullanılacak)
const internalModel = ref(false);

// Computed: modelValue varsa onu kullan, yoksa internalModel
const dialogModel = computed({
  get: () => (!$slots.activator ? $props.modelValue : internalModel.value),
  set: (val: boolean) => {
    if (!$slots.activator) {
      $emit('update:modelValue', val);
    } else {
      internalModel.value = val;
    }
  },
});

// toggle fonksiyonu
function toggleDialog() {
  dialogModel.value = !dialogModel.value;
}

function accept() {
  $emit('accept', true);
  if ($props.toggleAccept) {
    toggleDialog();
  }
}
</script>

<template>
  <span class="terms-and-agreement-dialog--activator">
    <slot name="activator" :toggleDialog="toggleDialog" />
  </span>
  <q-dialog v-model="dialogModel" persistent>
    <q-card>
      <q-card-section>
        <h1 class="text-h6">Kullanıcı Sözleşmesi</h1>
      </q-card-section>

      <q-separator />

      <q-card-section style="max-height: 50vh" class="scroll"
        ><p>
          Lütfen <a href="https://hazeljewellery.com" target="_blank">hazeljewellery.com</a> web sitemizi kullanmadan önce bu Kullanıcı Sözleşmesi’ni dikkatle okuyunuz.
          Siteyi kullanarak bu sözleşmedeki tüm şartları kabul etmiş sayılırsınız.
        </p>

        <h2>1. Taraflar</h2>
        <p>
          <strong>Firma:</strong> Hazel Jewellery <br />
          Vergi No:
        </p>
        <p><strong>Kullanıcı:</strong> Web sitesine üye olan veya hizmetlerden yararlanan internet kullanıcısıdır.</p>

        <h2>2. Sözleşmenin Konusu</h2>
        <p>Bu sözleşme, Hazel Jewellery tarafından sunulan ürün ve hizmetlerin kullanım koşullarını, tarafların hak ve yükümlülüklerini düzenler.</p>

        <h2>3. Tarafların Hak ve Yükümlülükleri</h2>
        <p><strong>Firma:</strong></p>
        <ul>
          <li>Ürün, hizmet ve fiyatlarda değişiklik yapma hakkına sahiptir.</li>
          <li>Site hizmetlerini teknik aksaklıklar dışında sunmayı taahhüt eder.</li>
          <li>Kişisel verileri KVKK kapsamında işler ve korur.</li>
          <li>Resmi talepler doğrultusunda kullanıcı bilgilerini paylaşabilir.</li>
        </ul>
        <p><strong>Kullanıcı:</strong></p>
        <ul>
          <li>Doğru ve güncel bilgi vermekle yükümlüdür.</li>
          <li>Hesap bilgilerini korumakla sorumludur.</li>
          <li>Site kullanımında yasalara ve ahlaka uygun davranmalıdır.</li>
          <li>Mesafeli Satış Sözleşmesi ve Ön Bilgilendirme Formu’na uymalıdır.</li>
        </ul>

        <h2>4. Fikri Mülkiyet Hakları</h2>
        <p>Sitedeki tüm içerik Hazel Jewellery’ye aittir. Yazılı izin olmadan çoğaltılamaz veya dağıtılamaz.</p>

        <h2>5. Kişisel Veriler ve Gizlilik</h2>
        <p>Kullanıcı bilgileri yalnızca hizmet sunmak, kampanyalar hakkında bilgilendirme yapmak ve analiz amacıyla kullanılır.</p>

        <h2>6. Garanti Verilmemesi</h2>
        <p>Site “olduğu gibi” sunulmaktadır. Kesintisiz hizmet garantisi verilmez.</p>

        <h2>7. Mücbir Sebepler</h2>
        <p>Doğal afet, savaş, salgın gibi mücbir sebepler nedeniyle hizmet aksaklıklarında Firma sorumlu tutulamaz.</p>

        <h2>8. Sözleşme Değişiklikleri ve Fesih</h2>
        <p>Firma sözleşmede değişiklik yapabilir. Değişiklikler sitede yayınlandığında yürürlüğe girer.</p>

        <h2>9. Bildirimler</h2>
        <p>Tüm bildirimler, kullanıcı ve firma tarafından sisteme tanımlanan e-posta adresleri üzerinden yapılır.</p>

        <h2>10. Delil Sözleşmesi</h2>
        <p>Firma kayıtları, geçerli delil olarak kabul edilir. Kullanıcı, bu kayıtlara itiraz etmeyeceğini kabul eder.</p>

        <h2>11. Uyuşmazlıkların Çözümü</h2>
        <p>Uyuşmazlıklarda Sivas Tüketici Hakem Heyeti ve Sivas Tüketici Mahkemeleri yetkilidir.</p>

        <h2>12. Yürürlük</h2>
        <p>Kullanıcı, siteye giriş yaparak veya hizmetleri kullanarak bu sözleşmeyi kabul etmiş sayılır.</p>
      </q-card-section>

      <q-separator />

      <q-card-actions align="right">
        <q-btn flat label="Reddet" color="primary" @click="toggleDialog" />
        <q-btn flat label="Kabul Ediyorum" color="primary" @click="accept" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped>
h1 {
  color: #444;
  font-size: 28px;
  margin: 0;
}

h2 {
  font-size: 22px;
  color: #444;
  font-weight: 600;
  margin: 0;
}

p {
  margin: 10px 0;
}
</style>
